<script>
import DefaultAside from '@/components/common/form-components/DefaultAside'
import Add from '@/components/exemption/form-components/Add'

export default {
  mixins: [DefaultAside],
  components: {
    add: Add
  }
}
</script>
